import { FormElement, FormRenderProps } from "@progress/kendo-react-form";
import { StartDealEntryQuote } from ".";
import { PropsWithChildren } from "react";
import StartVanillaQuote from "../vanilla/StartVanillaQuote";
import { Button } from "@progress/kendo-react-buttons";
import VanillaStructureContainer from "../vanilla/VanillaStructureContainer";


const Separator = () => {
  return <span className={"k-form-separator"} style={{ margin: "1rem 0" }} />;
};

interface IStepWrapperProps {
  showButton: boolean;
  onEditClick: (event: any) => void;
}

const StepWrapper = ({ showButton, onEditClick, children }: PropsWithChildren<IStepWrapperProps>) => {
  return (
    <div>
      {showButton && (
        <div className="float-right">
          <Button
            icon="pencil"
            themeColor="primary"
            fillMode="outline"
            title="Edit"
            size="medium"
            onClick={onEditClick}
          />
        </div>
      )}

      {children}
    </div>
  );
};


interface IDealEntryFormProps {
  step: number;
  formRenderProps: FormRenderProps;
  isLoading: boolean;
  isSubmitStep: boolean;
  isPreviousStepsValid: boolean;
  submitLabel: string;
  product: any;
  onCancelClick: (event: any) => void;
  onEditClick: (newStep: number) => void;
}

export const DealEntryFormRender = ({
  step,
  formRenderProps,
  isLoading,
  isSubmitStep,
  isPreviousStepsValid,
  submitLabel,
  product,
  onCancelClick,
  onEditClick,
}: IDealEntryFormProps) => {
  const disableSubmit = !(isPreviousStepsValid && formRenderProps.valid) || isLoading;

  const handleEditClick = (event: any, newStep: number) => {
    event.preventDefault();
    onEditClick(newStep);
  };

  const scrollToBottom = () => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        marginRight: 50,
        marginLeft: 50,
      }}
    >
      <FormElement>
        <Separator />
        {step >= 0 && (
          <StepWrapper showButton={step != 0} onEditClick={(e) => handleEditClick(e, 0)}>
            <StartDealEntryQuote readOnly={step != 0} formRenderProps={formRenderProps} />
          </StepWrapper>
        )}

        {step >= 1 && product && (
          <>
            <Separator />
            <StepWrapper showButton={step != 1} onEditClick={(e) => handleEditClick(e, 1)}>
              <StartVanillaQuote
                formRenderProps={formRenderProps}
                product={product}
                isDealEntry={true}
                readOnly={step != 1}
                onLoaded={scrollToBottom}
              />
            </StepWrapper>
          </>
        )}

        {step >= 2 && (
          <>
            <Separator />

            <StepWrapper showButton={step != 2} onEditClick={(e) => handleEditClick(e, step - 1)}>
              <div className="stepper-form" style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "80%" }}>
                  <VanillaStructureContainer
                    formRenderProps={formRenderProps}
                    step={step - 1}
                    product={product}
                    marketStatsResults={null}
                    structureName={""}
                    showAnalytics={false}
                    isDealEntry={true}
                    onLoaded={scrollToBottom}
                  />
                </div>
              </div>
            </StepWrapper>
          </>
        )}

        <Separator />

        <div style={{ display: "flex", justifyContent: "right" }}>
          <Button style={{ marginRight: "16px" }} onClick={onCancelClick}>
            Cancel
          </Button>
          <Button
            themeColor={"primary"}
            disabled={disableSubmit}
            onClick={formRenderProps.onSubmit}
          >
            {isSubmitStep ? submitLabel : "Next"}
          </Button>
        </div>
      </FormElement>
    </div>
  );
};
